export enum TicketType {
  Ticket = 1,
  Punch = 2,
}
